// extracted by mini-css-extract-plugin
module.exports = {"collapse":"CollapseIcon_collapse__3UJQP"};